// src/data/nomQuestions.js

import ABQuestion from '../components/questions/abQuestion/abQuestion';
import FrequencyQuestion from '../components/questions/frequencyQuestion/frequencyQuestion';
import DropdownQuestion from '../components/questions/dropdownQuestion/dropdownQuestion';
import TextQuestion from '../components/questions/textQuestion/textQuestion';
import mexicoStates from "../data/mexicoStates";
import ageRanges from "../data/ageRanges";

const questions = [
  // Datos generales
  {
    Component: TextQuestion,
    question: "Correo electrónico empresarial",
    field: "email",
    type: "email"
  },
  {
    Component: ABQuestion,
    question: "Sexo biológico",
    optionA: "Masculino",
    optionB: "Femenino",
    field: "biologicalSex"
  },
  {
    Component: DropdownQuestion,
    question: "Rango de edad",
    options: ageRanges,
    field: "ageRange"
  },

  // Guía I: Sección I (Sí/No)
  {
    Component: ABQuestion,
    question: '¿Ha presenciado o sufrido alguna vez, durante o con motivo del trabajo, un accidente que tenga como consecuencia la muerte, la pérdida de un miembro o una lesión grave?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionI_accidente',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha presenciado o sufrido alguna vez, durante o con motivo del trabajo, un asalto?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionI_asaltos',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha presenciado o sufrido un acto violento que derivó en lesiones graves?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionI_actosViolentos',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha sido víctima de un secuestro por motivos laborales?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionI_secuestro',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha recibido amenazas en el ámbito laboral?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionI_amenazas',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha ocurrido algún otro evento que puso en riesgo su vida o salud durante el trabajo?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionI_otroRiesgo',
    required: true
  },

  // Guía I: Sección II
  {
    Component: ABQuestion,
    question: '¿Ha tenido recuerdos recurrentes sobre el acontecimiento que le provocan malestares?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionII_recuerdosPersistentes',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha tenido sueños de carácter recurrente sobre el acontecimiento, que le producen malestar?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionII_suenosPersistentes',
    required: true
  },

  // Guía I: Sección III
  {
    Component: ABQuestion,
    question: '¿Se ha esforzado por evitar sentimientos, conversaciones o situaciones que le recuerden el acontecimiento?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIII_evitarSentimientos',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Se ha esforzado por evitar actividades, lugares o personas que motivan recuerdos del acontecimiento?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIII_evitarActividades',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha tenido dificultad para recordar alguna parte importante del evento?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIII_dificultadRecuerdo',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha disminuido su interés en sus actividades cotidianas?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIII_disminucionInteres',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Se ha sentido alejado o distante de los demás?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIII_distanciamiento',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha notado que tiene dificultad para expresar sus sentimientos?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIII_dificultadExpresion',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha tenido la impresión de que su vida se acortará, que morirá antes que otras personas o que tendrá un futuro limitado?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIII_impresionVidaLimitada',
    required: true
  },

  // Guía I: Sección IV
  {
    Component: ABQuestion,
    question: '¿Ha tenido dificultades para dormir?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIV_dificultadDormir',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha estado particularmente irritable o con arranques de coraje?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIV_irritabilidad',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha tenido dificultad para concentrarse?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIV_dificultadConcentracion',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Ha estado nervioso o en constante alerta?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIV_nerviosismo',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Se ha sobresaltado fácilmente por cualquier cosa?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'seccionIV_sobresalto',
    required: true
  },

  // Guía III: Bloque 1 (Condiciones ambientales)
  {
    Component: FrequencyQuestion,
    question: 'El espacio donde trabajo me permite realizar mis actividades de manera segura e higiénica.',
    field: 'bloque1_item1',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mi trabajo me exige hacer mucho esfuerzo físico.',
    field: 'bloque1_item2',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Me preocupa sufrir un accidente en mi trabajo.',
    field: 'bloque1_item3',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Considero que en mi trabajo se aplican las normas de seguridad y salud en el trabajo.',
    field: 'bloque1_item4',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Considero que las actividades que realizo son peligrosas.',
    field: 'bloque1_item5',
    required: true
  },

  // Bloque 2 (Cantidad y ritmo de trabajo)
  {
    Component: FrequencyQuestion,
    question: 'Por la cantidad de trabajo que tengo debo quedarme tiempo adicional a mi turno.',
    field: 'bloque2_item6',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Por la cantidad de trabajo que tengo debo trabajar sin parar.',
    field: 'bloque2_item7',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Considero que es necesario mantener un ritmo de trabajo acelerado.',
    field: 'bloque2_item8',
    required: true
  },

  // Bloque 3 (Esfuerzo mental)
  {
    Component: FrequencyQuestion,
    question: 'Mi trabajo exige que esté muy concentrado.',
    field: 'bloque3_item9',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mi trabajo requiere que memorice mucha información.',
    field: 'bloque3_item10',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'En mi trabajo tengo que tomar decisiones difíciles muy rápido.',
    field: 'bloque3_item11',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mi trabajo exige que atienda varios asuntos al mismo tiempo.',
    field: 'bloque3_item12',
    required: true
  },

  // Bloque 4 (Responsabilidad y control)
  {
    Component: FrequencyQuestion,
    question: 'En mi trabajo soy responsable de cosas de mucho valor.',
    field: 'bloque4_item13',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Respondo ante mi jefe por los resultados de toda mi área de trabajo.',
    field: 'bloque4_item14',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'En el trabajo me dan órdenes contradictorias.',
    field: 'bloque4_item15',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Considero que en mi trabajo me piden hacer cosas innecesarias.',
    field: 'bloque4_item16',
    required: true
  },

  // Bloque 5 (Jornada y conciliación)
  {
    Component: FrequencyQuestion,
    question: 'Trabajo horas extras más de tres veces a la semana.',
    field: 'bloque5_item17',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mi trabajo me exige laborar en días de descanso, festivos o fines de semana.',
    field: 'bloque5_item18',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Considero que el tiempo en el trabajo es mucho y perjudica mis actividades familiares o personales.',
    field: 'bloque5_item19',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Debo atender asuntos de trabajo cuando estoy en casa.',
    field: 'bloque5_item20',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Pienso en las actividades familiares o personales cuando estoy en mi trabajo.',
    field: 'bloque5_item21',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Pienso que mis responsabilidades familiares afectan mi trabajo.',
    field: 'bloque5_item22',
    required: true
  },

  // Bloque 6 (Autonomía y control) – ítems 23–28 invertidos
  {
    Component: FrequencyQuestion,
    question: 'Mi trabajo permite que desarrolle nuevas habilidades.',
    field: 'bloque6_item23',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'En mi trabajo puedo aspirar a un mejor puesto.',
    field: 'bloque6_item24',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Durante mi jornada de trabajo puedo tomar pausas cuando las necesito.',
    field: 'bloque6_item25',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Puedo decidir cuánto trabajo realizo durante la jornada laboral.',
    field: 'bloque6_item26',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Puedo decidir la velocidad a la que realizo mis actividades.',
    field: 'bloque6_item27',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Puedo cambiar el orden de las actividades que realizo.',
    field: 'bloque6_item28',
    required: true,
    invertOrder: true
  },

  // Bloque 7 (Cambios en el trabajo) – ítem 30 invertido
  {
    Component: FrequencyQuestion,
    question: 'Los cambios que se presentan en mi trabajo dificultan mi labor.',
    field: 'bloque7_item29',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Cuando se presentan cambios en mi trabajo se tienen en cuenta mis ideas o aportaciones.',
    field: 'bloque7_item30',
    required: true,
    invertOrder: true
  },

  // Bloque 8 (Capacitación e información) – ítems 31–36 invertidos
  {
    Component: FrequencyQuestion,
    question: 'Me informan con claridad cuáles son mis funciones.',
    field: 'bloque8_item31',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Me explican claramente los resultados que debo obtener.',
    field: 'bloque8_item32',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Me explican claramente los objetivos de mi trabajo.',
    field: 'bloque8_item33',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Me informan con quién puedo resolver problemas o asuntos de trabajo.',
    field: 'bloque8_item34',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Me permiten asistir a capacitaciones relacionadas con mi trabajo.',
    field: 'bloque8_item35',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Recibo capacitación útil para hacer mi trabajo.',
    field: 'bloque8_item36',
    required: true,
    invertOrder: true
  },

  // Bloque 9 (Liderazgo y relaciones) – ítems 37–41 invertidos
  {
    Component: FrequencyQuestion,
    question: 'Mi jefe ayuda a organizar mejor el trabajo.',
    field: 'bloque9_item37',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mi jefe tiene en cuenta mis puntos de vista y opiniones.',
    field: 'bloque9_item38',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mi jefe me comunica a tiempo la información relacionada con el trabajo.',
    field: 'bloque9_item39',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'La orientación que me da mi jefe me ayuda a realizar mejor mi trabajo.',
    field: 'bloque9_item40',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mi jefe ayuda a solucionar los problemas que se presentan en el trabajo.',
    field: 'bloque9_item41',
    required: true,
    invertOrder: true
  },

  // Bloque 10 (Apoyo social) – ítems 42–46 invertidos
  {
    Component: FrequencyQuestion,
    question: 'Puedo confiar en mis compañeros de trabajo.',
    field: 'bloque10_item42',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Entre compañeros solucionamos los problemas de trabajo de forma respetuosa.',
    field: 'bloque10_item43',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'En mi trabajo me hacen sentir parte del grupo.',
    field: 'bloque10_item44',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Cuando tenemos que realizar trabajo de equipo los compañeros colaboran.',
    field: 'bloque10_item45',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mis compañeros de trabajo me ayudan cuando tengo dificultades.',
    field: 'bloque10_item46',
    required: true,
    invertOrder: true
  },

  // Bloque 11 (Reconocimiento y pertenencia)
  {
    Component: FrequencyQuestion,
    question: 'Me informan sobre lo que hago bien en mi trabajo.',
    field: 'bloque11_item47',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'La forma como evalúan mi trabajo me ayuda a mejorar mi desempeño.',
    field: 'bloque11_item48',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'En mi centro de trabajo me pagan a tiempo mi salario.',
    field: 'bloque11_item49',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'El pago que recibo es el que merezco por el trabajo que realizo.',
    field: 'bloque11_item50',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Si obtengo los resultados esperados me recompensan o reconocen.',
    field: 'bloque11_item51',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Las personas que hacen bien el trabajo pueden crecer laboralmente.',
    field: 'bloque11_item52',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Inestabilidad laboral en mi centro de trabajo.',
    field: 'bloque11_item53',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Existe continua rotación de personal en mi trabajo.',
    field: 'bloque11_item54',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Siento orgullo de laborar en este centro de trabajo.',
    field: 'bloque11_item55',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Me siento comprometido con mi trabajo.',
    field: 'bloque11_item56',
    required: true,
    invertOrder: true
  },

  // Bloque 12 (Violencia laboral) – ítem 57 invertido
  {
    Component: FrequencyQuestion,
    question: 'En mi trabajo puedo expresarme libremente sin interrupciones.',
    field: 'bloque12_item57',
    required: true,
    invertOrder: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Recibo críticas constantes a mi persona y/o trabajo.',
    field: 'bloque12_item58',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Recibo burlas, calumnias, difamaciones, humillaciones o ridiculizaciones.',
    field: 'bloque12_item59',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Se ignora mi presencia o se me excluye de las reuniones y toma de decisiones.',
    field: 'bloque12_item60',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Se manipulan situaciones de trabajo para hacerme parecer mal trabajador.',
    field: 'bloque12_item61',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Se ignoran mis éxitos laborales y se atribuyen a otros.',
    field: 'bloque12_item62',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Me bloquean oportunidades de ascenso o mejora.',
    field: 'bloque12_item63',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'He presenciado actos de violencia en mi centro de trabajo.',
    field: 'bloque12_item64',
    required: true
  },

  // Bloque 13 & 14 (ABQuestion + FrequencyQuestion)
  {
    Component: ABQuestion,
    question: '¿En mi trabajo debo brindar servicio a clientes o usuarios?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'bloque13_attention',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Atiendo clientes o usuarios muy enojados.',
    field: 'bloque13_item65',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mi trabajo me exige atender personas muy necesitadas de ayuda o enfermas.',
    field: 'bloque13_item66',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Para hacer mi trabajo debo demostrar sentimientos distintos a los míos.',
    field: 'bloque13_item67',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mi trabajo me exige atender situaciones de violencia.',
    field: 'bloque13_item68',
    required: true
  },
  {
    Component: ABQuestion,
    question: '¿Soy jefe de otros trabajadores?',
    optionA: 'Sí',
    optionB: 'No',
    field: 'bloque14_supervisor',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mis supervisados comunican tarde los asuntos de trabajo.',
    field: 'bloque14_item69',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mis supervisados dificultan el logro de los resultados del trabajo.',
    field: 'bloque14_item70',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mis supervisados cooperan poco cuando se les necesita.',
    field: 'bloque14_item71',
    required: true
  },
  {
    Component: FrequencyQuestion,
    question: 'Mis supervisados ignoran las sugerencias para mejorar su trabajo.',
    field: 'bloque14_item72',
    required: true
  }
];

export default questions;
